import { useAtomValue } from 'jotai';
import { loggerAtom } from '../logger/logger-atom';
export const useLogger = () => {
  const logger = useAtomValue(loggerAtom);
  return logger;
};